import { useQuery } from '@tanstack/react-query';
import api from '../../http';

export interface ActiveIngredientDTO {
	_id: string;
	name: string;
	userId?: string | null;
}

export interface PaginatedActiveIngredientsResponse {
	docs: ActiveIngredientDTO[];
	totalDocs: number;
	limit: number;
	totalPages: number;
	page: number;
}

export interface UseGetActiveIngredientsParams {
	page?: number;
	limit?: number;
	enabled?: boolean;
}

export function useGetActiveIngredients({
	page = 1,
	limit = 1000,
	enabled = true,
}: UseGetActiveIngredientsParams = {}) {
	const query = useQuery<PaginatedActiveIngredientsResponse>({
		queryKey: ['active-ingredients', page, limit],
		enabled,
		queryFn: async () => {
			const { data } = await api.get<PaginatedActiveIngredientsResponse>('/active-ingredients/findAll', {
				params: { page, limit },
			});
			return data;
		},
	});

	return {
		...query,
		data: query.data?.docs ?? [],
		pagination: query.data
			? { totalDocs: query.data.totalDocs, totalPages: query.data.totalPages, page: query.data.page }
			: null,
	};
}
